export const CREATE_POST_REQUEST = "CREATE_POST_REQUEST";
export const CREATE_POST_SUCCESS = "CREATE_POST_SUCCESS";
export const CREATE_POST_FAIL = "CREATE_POST_FAIL";
export const CLEAR_ERRORS = "CLEAR_ERRORS";

export const ALL_POSTS_REQUEST = "ALL_POSTS_REQUEST";
export const ALL_POSTS_SUCCESS = "ALL_POSTS_SUCCESS";
export const ALL_POSTS_FAIL = "ALL_POSTS_FAIL";

export const CHANGE_STATUS_REQUEST = "CHANGE_STATUS_REQUEST";
export const CHANGE_STATUS_SUCCESS = "CHANGE_STATUS_SUCCESS";
export const CHANGE_STATUS_FAIL = "CHANGE_STATUS_FAIL";

export const SAVED_POSTS_REQUEST = "SAVED_POST_REQUEST";
export const SAVED_POSTS_SUCCESS = "SAVED_POST_SUCCESS";
export const SAVED_POSTS_FAIL = "SAVED_POSTS_FAIL";

export const LIKED_POSTS_REQUEST = "LIKED_POSTS_REQUEST";
export const LIKED_POSTS_SUCCESS = "LIKED_POSTS_SUCCESS";
export const LIKED_POSTS_FAIL = "LIKED_POSTS_FAIL";

export const CREATE_YEARLY_PLAN_REQUEST = "CREATE_YEARLY_PLAN_REQUEST";
export const CREATE_YEARLY_PLAN_SUCCESS = "CREATE_YEARLY_PLAN_SUCCESS";
export const CREATE_YEARLY_PLAN_FAIL = "CREATE_YEARLY_PLAN_FAIL";

export const GET_YEARLY_PLAN_REQUEST = "GET_YEARLY_PLAN_REQUEST";
export const GET_YEARLY_PLAN_SUCCESS = "GET_YEARLY_PLAN_SUCCESS";
export const GET_YEARLY_PLAN_FAIL = "GET_YEARLY_PLAN_FAIL";

export const MY_YEAR_PLANS_REQUEST = "MY_YEAR_PLANS_REQUEST";
export const MY_YEAR_PLANS_SUCCESS = "MY_YEAR_PLANS_SUCCESS";
export const MY_YEAR_PLANS_FAIL = "MY_YEAR_PLANS_FAIL";

export const TOGGLE_PRIORITY_REQUEST = "TOGGLE_PRIORITY_REQUEST";
export const TOGGLE_PRIORITY_SUCCESS = "TOGGLE_PRIORITY_SUCCESS";
export const TOGGLE_PRIORITY_FAIL = "TOGGLE_PRIORITY_FAIL";

export const SAVED_PLANS_REQUEST = "SAVED_PLANS_REQUEST";
export const SAVED_PLANS_SUCCESS = "SAVED_PLANS_SUCCESS";
export const SAVED_PLANS_FAIL = "SAVED_PLANS_FAIL";
